import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { TextField } from '@/components/functional/Form/TextField';
import { FieldLabel } from '@/components/ui/Form/FieldLabel';
import { validatePasswordConfirm } from '@/utils/validate/resources/password/passwordReset';
/**
 * パスワード再設定 パスワード(確認用)
 */
export const PasswordResetEditPasswordConfirmField = (props) => {
    const { className = '', name } = props;
    return (_jsx(FieldLabel, Object.assign({ className: className, labelText: '新しいパスワード（確認用）' }, { children: _jsx(TextField, { inputProps: { autoComplete: 'off' }, name: name, type: 'password', validate: validatePasswordConfirm }) })));
};
